import React, { FunctionComponent } from 'react';
import { Text, ITextProps } from '../text/text';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import styles from './text-with-image-outside.module.scss';

export interface ITextWithImageOutsideProps {
  image: {
    url: string;
    description: string;
  };
  header: ITextProps[];
  description: string;
  reversed: boolean;
  backgroundColor: string;
  imagePostion: string;
  id?: string;
}

const cx = classNames.bind(styles);

export const TextWithImageOutside: FunctionComponent<ITextWithImageOutsideProps> = ({
  image,
  header,
  description,
  reversed,
  backgroundColor,
  imagePostion,
  id
}) => {
  const wrapperClassname = cx({
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    marginTop: imagePostion === 'top',
    marginBottom: imagePostion === 'bottom'
  });

  const imageWrapperClassname = cx({
    imagePostionTop: imagePostion === 'top',
    imagePostionBottom: imagePostion === 'bottom'
  });

  return (
    <div className={`${wrapperClassname} ${styles.wrapper}`} id={id ? id : ''}>
      <div className={styles.container}>
        <div
          className={`${styles.contentWrapper} ${reversed && styles.reversed}`}
        >
          <div className={styles.textWrapper}>
            {!isEmpty(header) ? (
              <div className={styles.header}>
                {header.map((text: ITextProps, i) => (
                  <Text {...text} key={i} />
                ))}
              </div>
            ) : null}
            {!isEmpty(description) ? (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            ) : null}
          </div>
          <div className={`${styles.imageWrapper}`}>
            <div className={`${styles.image} ${imageWrapperClassname}`}>
              <img src={image.url} alt={image.description} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
